import type { Status, EscalationStatus, AvailabilityState } from '../state/store.js';
import { STRINGS } from '../strings.js';

type Props = {
  status: Status;
  escalation: EscalationStatus;
  availability: AvailabilityState;
  availabilityMessage: string;
  onRetry: () => void;
};

export function StatusBanner({
  status,
  escalation,
  availability,
  availabilityMessage,
  onRetry,
}: Props) {
  if (status === 'reconnecting') {
    return (
      <div
        style={{
          padding: '8px 16px',
          backgroundColor: '#fff3cd',
          color: '#664d03',
          fontSize: '13px',
          textAlign: 'center',
        }}
      >
        {STRINGS.connectionLost}
      </div>
    );
  }
  if (status === 'failed') {
    return (
      <div
        style={{
          padding: '8px 16px',
          backgroundColor: '#f8d7da',
          color: '#842029',
          fontSize: '13px',
          textAlign: 'center',
        }}
      >
        {STRINGS.connectionFailed}
        <button
          type="button"
          onClick={onRetry}
          style={{ marginLeft: '8px', padding: '4px 8px', cursor: 'pointer' }}
        >
          {STRINGS.retry}
        </button>
      </div>
    );
  }
  if (escalation === 'agent_joined') {
    return (
      <div
        style={{
          padding: '8px 16px',
          backgroundColor: '#e7f3ff',
          color: '#0a4a85',
          fontSize: '13px',
          textAlign: 'center',
        }}
      >
        {STRINGS.agentJoined}
      </div>
    );
  }
  if (availability !== 'unknown' && availabilityMessage) {
    const isOnline = availability === 'online';
    return (
      <div
        style={{
          padding: '8px 16px',
          backgroundColor: isOnline ? '#e6f4ea' : '#fff3cd',
          color: isOnline ? '#1e4620' : '#664d03',
          fontSize: '13px',
          textAlign: 'center',
        }}
      >
        {availabilityMessage}
      </div>
    );
  }
  return null;
}
